<template>
  <div
    class="max-w-sm w-full"
  >
    <div class="rounded-xl overflow-hidden shadow-xl p-4 transition-all duration-300 ease-in-out transform border border-opacity-20"
         :class="[
           toast.bgColor,
           toast.textColor,
           isVisible ? 'translate-x-0 opacity-100 scale-100' : 'translate-x-full opacity-0 scale-95'
         ]">
      <div class="flex items-start">
        <!-- Icon -->
        <div class="flex-shrink-0 mr-3">
          <svg v-if="toast.icon === 'checkmark'" class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
          </svg>
          <svg v-else-if="toast.icon === 'error'" class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
          <svg v-else-if="toast.icon === 'warning'" class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
          </svg>
          <svg v-else-if="toast.icon === 'info'" class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>

        <!-- Message -->
        <div class="flex-1 min-w-0">
          <p class="text-sm font-medium leading-5">
            {{ toast.message }}
          </p>
          <IssueReportPrompt
            v-if="toast.type === 'error'"
            class="toast-report"
            :issue-type="toast.reportContext?.issueType || 'user_visible_error'"
            :surface="toast.reportContext?.surface || 'global_toast'"
            :resource-type="toast.reportContext?.resourceType || null"
            :resource-id="toast.reportContext?.resourceId || null"
            :error-message="toast.message"
            :metadata="{ toastId: toast.id, ...(toast.reportContext?.metadata || {}) }"
          />
        </div>

        <!-- Close Button -->
        <div v-if="toast.dismissible" class="flex-shrink-0 ml-3">
          <button
            @click="dismiss"
            class="inline-flex rounded-md p-1.5 hover:bg-white hover:bg-opacity-20 focus:outline-none focus:ring-2 focus:ring-white transition-colors duration-200"
            :class="toast.textColor"
          >
            <span class="sr-only">Dismiss</span>
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IssueReportPrompt from '@/components/IssueReportPrompt.vue';

export default {
  name: 'Toast',
  components: { IssueReportPrompt },
  props: {
    toast: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isVisible: false
    }
  },
  mounted() {
    // Trigger entrance animation
    this.$nextTick(() => {
      this.isVisible = true
    })
  },
  methods: {
    dismiss() {
      this.isVisible = false
      // Wait for animation to complete before emitting
      setTimeout(() => {
        this.$emit('dismiss', this.toast.id)
      }, 300)
    }
  }
}
</script>

<style scoped>
.toast-report {
  justify-content: flex-start;
  color: rgba(255, 255, 255, 0.92);
  --accent: #fff;
  --success-600: #fff;
}
</style>
